window.videoData = {
    playlists: [
        {
            id: '1',
            playlist: "Money Mentors",
            title: "Money Mentors",
            videos: [
                {
                     "id": 'lgn73tDSlB8',
                     "title": "Ep 1 - The Power of Compounding",
                     "views": "",
                     "duration": "1:23",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": "x6-wCMuEi1s",
                     "title": "Ep 2 - Investments: Getting Started",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": '27q8Gf_J0yM',
                     "title": "Ep 3 - Tax planning ",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": 'NrOXdtxmXvU',
                     "title": "Ep 4 - Contingency and Planning",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": 'oGBln0PVyqI',
                     "title": "Ep 5 - Planning your financial goals",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": 'HOcK5dmGAUA',
                     "title": "Ep 6 - Mutual Funds Primer",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": '_Gog4FvG2iE',
                     "title": "Ep 7 - Equity Portfolio",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": 'hdTgtoaKIWU',
                     "title": "Ep 8 - Financial Freedom",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": 'XkW6Q7XOZHk',
                     "title": "Ep 9 - Retirement Planning",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
                 {
                     "id": 'DB2bAdR_gcY',
                     "title": "Ep 10 - Short-tem equity investment strategy",
                     "views": "",
                     "duration": "",
                     "playlistName": "Money Mentors",
                 },
             ]
        },
        {
            id: '2',
            playlist: "Share market for beginners",
            title: "Share market for beginners",
            videos: [
                {
                     "id": 'lX5OSd9ATz0',
                     "title": "Difference Between Trading And Demat",
                     "views": "",
                     "duration": "1:23",
                     "playlistName": "Share market for beginners ",
                 },
                 {
                     "id": "gFi3hAC5aDQ",
                     "title": "Beginner's guide on stock market",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners ",
                 },
                 {
                     "id": 'jq4HbAOjJ7I',
                     "title": "Top 5 reasons to invest in share market",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners ",
                 },
                 {
                     "id": 'E39gU8598bo',
                     "title": "Share market investment guidance for beginners",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners ",
                 },
                 {
                     "id": 'UIacQLRIP34',
                     "title": "Myths about the stock market",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'qmzqN9Lh1vE',
                     "title": "5 things to keep in mind before investing",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'RJQSQ7a6k7U',
                     "title": "Characteristics of a Good Investment Strategy",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'ER3-51z3caU',
                     "title": "Every Stock You Buy, Things To Keep In Mind",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": '_OfqTqtOL7w',
                     "title": "How to invest in stocks with low funds",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'ylCYy1uhIhY',
                     "title": "Stock Market investment Strategies",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'U4bkuKFIgeI',
                     "title": "Common trading mistakes and how to avoid them",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'kmkxPI4LpQk',
                     "title": "Things to consider before investing in an IPO",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
                 {
                     "id": 'xVATpVtATQ8',
                     "title": "All you need to know about IPO allotment",
                     "views": "",
                     "duration": "",
                     "playlistName": "Share market for beginners",
                 },
             ]
        },
      
        {
          id: '3',
          thumbnail: 'https://via.placeholder.com/400x300',
          playlist: "Corporate Actions",
          title: "Corporate Actions",
           videos: [
                {
                     "id": 'IJey4BMJk-U',
                     "title": "Dividends Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "1:23",
                     "playlistName": "Corporate Actions",
                 },
                 {
                     "id": "mOikcjLXNSg",
                     "title": "Bonus Shares Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Corporate Actions",
                 },
                 {
                     "id": 'Cz_BHDW2hU4',
                     "title": "Understanding Rights Issue | Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Corporate Actions",
                 },
                 {
                     "id": 'Kv9iSpA_SU0',
                     "title": "Stock Splits Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Corporate Actions",
                 },
                 {
                     "id": 'MXNetBfsXi4',
                     "title": "Share Buyback Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Corporate Actions",
                 },
             ]
       },
       {
          id: '4',
          thumbnail: 'https://via.placeholder.com/400x300',
          playlist: "Balance Sheet Explained",
          title: "Balance Sheet Explained",
           videos: [
                {
                     "id": 'oRkefjA7RTQ',
                     "title": "How to Analyze a Balance Sheet Learn with Upstox ft CA Rachana Ranade",
                     "views": "",
                     "duration": "1:23",
                     "playlistName": "Balance Sheet Explained",
                 },
                 {
                     "id": "MunBAAaGckE",
                     "title": "Outstanding Share Capital Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Balance Sheet Explained",
                 },
                 {
                     "id": 'QlGGMaCPeq0',
                     "title": "Book value Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Balance Sheet Explained",
                 },
                 {
                     "id": 'Pv-_VlNX950',
                     "title": "Contingent liabilities Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "Balance Sheet Explained",
                 },
             ]
       },
       {
          id: '5',
          thumbnail: 'https://via.placeholder.com/400x300',
          playlist: "P&L & Ratios Explained",
          title: "P&L & Ratios Explained",
           videos: [
                {
                     "id": '46JoI0JUVmc',
                     "title": "Volume, realisation, and revenues explained Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "1:23",
                     "playlistName": "P&L & Ratios Explained",
                 },
                 {
                     "id": "5eWYhxBo8AU",
                     "title": "Ratio Analysis Learn with Upstox ft. CA Rachana Ranade",
                     "views": "",
                     "duration": "",
                     "playlistName": "P&L & Ratios Explained",
                 },
                 {
                     "id": 'QRe_WQOO2fk',
                     "title": "PE Ratio Learn with Upstox ft Aaditya Iyengar",
                     "views": "",
                     "duration": "",
                     "playlistName": "P&L & Ratios Explained",
                 },
             ]
       },
    ],
    images: [
        {
            id: 1,
            path:"https://img.youtube.com/vi/ANdwvD8BoSA/maxresdefault.jpg",
        },
        {
            id: 2,
            path:"https://img.youtube.com/vi/ANdwvD8BoSA/maxresdefault.jpg",
        },
        {
            id: 3,
            path:"https://img.youtube.com/vi/ANdwvD8BoSA/maxresdefault.jpg",
        },
        {
            id: 4,
            path:"https://img.youtube.com/vi/ANdwvD8BoSA/maxresdefault.jpg",
        },
        {
            id: 5,
            path:"https://img.youtube.com/vi/ANdwvD8BoSA/maxresdefault.jpg",
        }
    ]
  }